export const html: string = `<div class="book-search-ctl-lower">
	<form data-myon-name="formEl">
		<div class="searchLg" data-myon-name="tabset">
			<div class="searchLg_tabs" data-myon-name="tablist" role="tablist">
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnFilter" role="presentation">
					<div class="searchLg_tabIcon -search flex_item -grow flex -column -center">
						 <i class="fIcon -ll-filter" ></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_INCLUDE }}</span>
				</button>
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnFiction" role="presentation">
					<div class="searchLg_tabIcon -fiction flex_item -grow flex -column -center">
						 <i class="fIcon -ll-fnf"></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_FICTION }}</span>
				</button>
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnLexile" role="presentation">
					<div class="searchLg_tabIcon -lexile flex_item -grow flex -column -center">
						 <i class="fIcon -ll-lexile" ></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_LEXILE }}</span>
				</button>
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnAtos" role="presentation">
					<div class="searchLg_tabIcon -atos flex_item -grow flex -column -center">
						 <i class="fIcon -ll-atos" ></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_ATOS }}</span>
				</button>
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnReading" role="presentation">
					<div class="searchLg_tabIcon -guidedReading flex_item -grow flex -column -center">
						 <i class="fIcon -ll-guidedReading" ></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_READING_LEVEL }}</span>
				</button>
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnGrade" role="presentation">
					<div class="searchLg_tabIcon -gradeLevel flex_item -grow flex -column -center">
						 <i class="fIcon -ll-gradeLevel" ></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_GRADE_LEVEL }}</span>
				</button>
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnLength" role="presentation">
					<div class="searchLg_tabIcon -length flex_item -grow flex -column -center">
						 <i class="fIcon -ll-storyLength" ></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_STORY_TYPE }}</span>
				</button>
				<button type="button" class="searchLg_tab searchLg_labelledIcon flex -column -center" data-myon-name="filterBtnLanguage" role="presentation">
					<div class="searchLg_tabIcon -language flex_item -grow flex -column -center">
						 <i class="fIcon -ll-lang"></i>
					</div>
					<span class="flex_item">{{ lang.LABEL_LANGUAGE }}</span>
				</button>
			</div>

			<div class="searchLg_contents" data-myon-name="tabpanelContainer" role="presentation">
				<div class="searchLg_content -hidden" data-filter-panel="search" data-myon-name="filterPanelFilter">
					<fieldset class="searchLg_fieldset flex -column -center">
						<legend class="g_screenReader">{{ lang.LABEL_INCLUDE }}</legend>
						<ul class="searchLg_toggles flex -row -gutter">
							<li data-myon-template="searchFields" class="searchLg_toggle -wide">
								<i data-myon-attr-class="searchLg_toggleIcon {{ icon }}"></i>
								<input type="checkbox" class="searchLg_toggleCheck checkbox -darkContainer -beefy" name="search[]" data-myon-name="checkbox" id="search-ctl-{{ id }}" value="{{ id }}" aria-labelledby="search-label-{{ id }}" />
								<label class="searchLg_toggleLabel" for="search-ctl-{{ id }}">{{ label }}</label>
							</li>
						</ul>
					</fieldset>
				</div>
				<div data-filter-panel="fiction" class="searchLg_content -hidden searchLg_fictionFilter" data-myon-name="filterPanelFiction">
					<i class="searchLg_fictionImage fIcon -ll-fnf-fiction" aria-hidden="true"></i>
					<i class="searchLg_fictionImage -nonfiction fIcon -ll-fnf-nonfiction" aria-hidden="true"></i>
					<div class="searchLg_fictionGroup">
						<input id="toggle-fiction" type="checkbox" class="checkbox -beefy -darkContainer" name="fiction[]" value="1" aria-describedby="fiction-descr">
						<label for="toggle-fiction">{{ lang.LABEL_FICTION }}</label>
						<p id="fiction-descr">{{ lang.LABEL_FICTION_DESCR }}</p>
					</div>

					<div class="searchLg_fictionGroup">
						<input id="toggle-nonfiction" type="checkbox" class="checkbox -beefy -darkContainer" name="fiction[]" value="0" aria-describedby="nonfiction-descr">
						<label for="toggle-nonfiction">{{ lang.LABEL_NONFICTION }}</label>
						<p id="nonfiction-descr">{{ lang.LABEL_NONFICTION_DESCR }}</p>
					</div>
				</div>
				<div class="searchLg_content -hidden" data-filter-panel="lexile" data-myon-name="filterPanelLexile">
					<fieldset class="searchLg_fieldset flex -column -center">
						<legend class="g_screenReader">{{ lang.LABEL_LEXILE }}</legend>
						<ul class="searchLg_toggles">
							<li data-myon-template="lexileToggles" class="searchLg_toggle">
								<input type="radio" class="searchLg_toggleCheck checkbox -darkContainer -beefy" name="lexile" data-myon-name="input" id="filter-lexile-{{ id }}" value="{{ id }}">
								<label data-myon-on-click="handleRadioLabelClick" for="filter-lexile-{{ id }}" class="searchLg_toggleLabel">
									{{ label }}
								</label>
							</li>
						</ul>
						<div class="searchLg_suggestion" id="lexile-suggestion" data-myon-name="lexileSuggestion" style="display:none">
							<div>{{ lang.LABEL_BEST_LEXILE }}</div>
							<i class="fIcon -ll-you-are-here"></i>
						</div>
					</fieldset>
				</div>
				<div class="searchLg_content -hidden" data-filter-panel="atos" data-myon-name="filterPanelAtos">
					<fieldset class="searchLg_fieldset flex -column -center">
						<legend class="g_screenReader">{{ lang.LABEL_ATOS }}</legend>
						<ul class="searchLg_toggles">
							<li data-myon-template="atosToggles" class="searchLg_toggle">
								<input id="filter-atos-{{ id }}" type="radio" class="checkbox -beefy searchLg_toggleCheckbox -darkContainer" name="atos" value="{{ id }}">
								<label for="filter-atos-{{ id }}" data-myon-on-click="handleRadioLabelClick" class="searchLg_toggleLabel">
									{{ label }}
								</label>
							</li>
						</ul>
					</fieldset>
				</div>
				<div class="searchLg_content -hidden" data-filter-panel="guidedReading" data-myon-name="filterPanelReading">
					<fieldset class="searchLg_fieldset">
						<legend class="g_screenReader">{{ lang.LABEL_READING_LEVEL }}</legend>
						<div class="flex -column -center">
							<ul class="searchLg_toggles -zebra">
								<li data-myon-template="guidedReadingRow1" class="searchLg_toggle">
									<input id="guided-reading-{{ id }}" type="radio" class="checkbox -beefy searchLg_toggleCheckbox -darkContainer" name="guidedReading" value="{{ id }}">
									<label for="guided-reading-{{ id }}" data-myon-on-click="handleRadioLabelClick" class="searchLg_toggleLabel">
										{{ label }}
									</label>
								</li>
							</ul>
							<ul class="searchLg_toggles -zebra">
								<li data-myon-template="guidedReadingRow2" class="searchLg_toggle">
									<input id="guided-reading-{{ id }}" type="radio" class="checkbox -beefy searchLg_toggleCheckbox -darkContainer" name="guidedReading" value="{{ id }}">
									<label for="guided-reading-{{ id }}" data-myon-on-click="handleRadioLabelClick" class="searchLg_toggleLabel">
										{{ label }}
									</label>
								</li>
							</ul>
						</div>
					</fieldset>
				</div>
				<div class="searchLg_content -hidden" data-filter-panel="gradeLevel" data-myon-name="filterPanelGrade">
					<fieldset class="searchLg_fieldset">
						<legend class="g_screenReader">{{ lang.LABEL_GRADE_LEVEL }}</legend>
						<ul class="searchLg_toggles">
							<li data-myon-template="gradeLevels" class="searchLg_toggle">
								<input id="grade-level-{{ id }}" type="radio" data-myon-name="input" class="checkbox -beefy searchLg_toggleCheckbox -darkContainer" name="gradeLevel" value="{{ id }}">
								<label for="grade-level-{{ id }}" data-myon-on-click="handleRadioLabelClick" class="searchLg_toggleLabel">
									{{ label }}
								</label>
							</li>
						</ul>
						<div class="searchLg_suggestion" data-myon-name="gradeSuggestion" id="grade-suggestion" style="display:none">
							<div>{{ lang.LABEL_YOUR_GRADE }}</div>
							<i class="fIcon -ll-you-are-here"></i>
						</div>
					</fieldset>
				</div>
				<div class="searchLg_content -hidden searchLg_fieldset flex -row -gutter -center" data-filter-panel="length" data-myon-name="filterPanelLength">
					<fieldset class="searchLg_fieldset flex_item -grow:2x flex -column -center">
						<legend class="searchLg_legend">{{ lang.LABEL_STORY_LENGTH }}</legend>
						<ul class="searchLg_toggles">
							<li data-myon-template="lengthBtns" class="searchLg_toggle -medium">
								<div class="flex_item -grow flex -center searchLg_storyLengthIconContainer">
									<i data-myon-attr-class="{{ icon }}"></i>
								</div>
								<input type="radio" class="checkbox -beefy searchLg_toggleCheckbox -darkContainer" id="filter-length-{{ id }}" name="length" value="{{ id }}">
								<label data-myon-on-click="handleRadioLabelClick" for="filter-length-{{ id }}" class="searchLg_toggleLabel">
									{{ label }}
								</label>
							</li>
						</ul>
					</fieldset>
					<fieldset class="searchLg_fieldset flex_item -grow flex -column -center">
						<legend class="searchLg_legend">{{ lang.LABEL_STORY_AUDIO }}</legend>
						<ul class="searchLg_toggles">
							<li data-myon-template="audioBtns" class="searchLg_toggle -medium">
								<div class="icon-audio-container">
									<i data-myon-attr-class="{{ icon }}"></i>
								</div>
								<input id="filter-audio-{{ id }}" type="checkbox" class="checkbox -beefy searchLg_toggleCheckbox -darkContainer" name="audio[]" value="{{ id }}">
								<label for="filter-audio-{{ id }}" class="searchLg_toggleLabel">
									{{ label }}
								</label>
							</li>
						</ul>
					</fieldset>
				</div>
				<div class="searchLg_content -hidden" data-filter-panel="language" data-myon-name="filterPanelLanguage">
					<fieldset class="searchLg_fieldset">
						<legend class="g_screenReader">{{ lang.LABEL_LANGUAGE }}</legend>
						<ul class="searchLg_toggles -wrap">
							<li data-myon-template="languageToggles" lang="{{ lang }}" class="searchLg_toggle -grouped -horizontal">
								<input id="filter-language-{{ id }}" type="checkbox" class="checkbox -beefy searchLg_toggleCheckbox -darkContainer" name="language[]" value="{{ id }}">
								<label for="filter-language-{{ id }}" class="searchLg_toggleLabel">
									{{ label }}
								</label>
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
		</div>

		<div class="search_reset-button" id="reset-button" data-myon-name="buttonContainer">
			<button type="button" class="button -darkContainer" aria-label="{{ lang.LABEL_CLEAR_FILTERS }}" data-myon-on-click="handleResetButtonClick">
				<i class="button_icon mycon -return"></i>
			</button>
		</div>
	</form>
</div>`;
